import { ShowStatus } from "../enums/ShowStatus";


export const ShowStatusOptions = [
  {
    key: 'Unknown',
    value: ShowStatus.Unknown,
  },
  {
    key: 'Not Recognized',
    value: ShowStatus.NotRecognized,
  },
  {
    key: 'Imported',
    value: ShowStatus.Imported,
  },
  {
    key: 'Published',
    value: ShowStatus.Published,
  },
];
